import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AdminTemplatesGate from "#/admin/templates/components/AdminTemplatesGate";
import TemplateForm, {
  TemplateFormPayload,
  TemplateFormValues,
} from "#/admin/templates/components/TemplateForm";
import useAdminTemplateMutations from "#/admin/templates/hooks/useAdminTemplateMutations";
import Typography from "#/components/shared/typography";

const initialValues: TemplateFormValues = {
  name: "",
  body: "",
  title: "",
  description: "",
  isActive: false,
  userVariableKeys: "",
};

export default function AdminTemplateCreatePage() {
  const navigate = useNavigate();
  const { createTemplate } = useAdminTemplateMutations();

  const serverError = useMemo(() => {
    if (!createTemplate.error) return null;
    return createTemplate.error instanceof Error
      ? createTemplate.error.message
      : "Unable to create template.";
  }, [createTemplate.error]);

  const handleSubmit = async (payload: TemplateFormPayload) => {
    try {
      const result = await createTemplate.mutateAsync(payload);
      if (result?.id) {
        navigate(`/admin/templates/${result.id}/edit`);
      }
    } catch {
      // errors are handled via toast + inline message
    }
  };

  return (
    <AdminTemplatesGate>
      <div className="container mx-auto flex flex-col gap-6 px-4 py-6">
        <div className="flex flex-col gap-2">
          <Typography variant="h2" className="text-brown-900">
            Create draft template
          </Typography>
          <Typography variant="body1" className="text-brown-600">
            Draft templates are saved in the admin system for review.
          </Typography>
        </div>

        <TemplateForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          submitLabel="Create draft"
          isSubmitting={createTemplate.isPending}
          serverError={serverError}
        />
      </div>
    </AdminTemplatesGate>
  );
}
